{
  "id": "campaign-009",
  "name": "Mossy Backyard",
  "seed": "campaign:9",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..........",
    ".....B....",
    "__________",
    "..h.......",
    "..........",
    ".,........",
    "..,..h....",
    ".,........",
    "........#.",
    "...,..#...",
    "S...,....."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 6,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 3
    }
  ],
  "generatorVersion": 3,
  "level": 9,
  "biome": "backyard",
  "par": {
    "reel": 4010,
    "push": 3181,
    "selfPropelled": 2838,
    "tractor": 2665,
    "zeroTurn": 1997,
    "fairway": 1279
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 4,
      "tractor": 11,
      "zeroTurn": 0,
      "fairway": 21
    }
  }
}
